const { ApolloClient } = require("apollo-client");
const { gql } = require("apollo-boost");
const fetch = require("cross-fetch/polyfill").fetch;
const createHttpLink = require("apollo-link-http").createHttpLink;
const InMemoryCache = require("apollo-cache-inmemory").InMemoryCache;

console.log("cylin", process.env.REACT_APP_URL_API_DLL);


const client = new ApolloClient({
  link: createHttpLink({
    uri: process.env.REACT_APP_URL_API_DLL,
    fetch: fetch
  }),
  cache: new InMemoryCache()
});

const CilynderModel = () => {
  const ModelHeating = async (temperature, heating_ramp, diameter) => {
    const CONSULTA = gql`{
      runModeloCalentamiento (TemperaturaHorno: ${temperature}, VelocidadDeCalentamiento: ${heating_ramp}, Diametro: ${diameter} ) {
        TiempoOptimoHorno
        error
      }
    }`;

    return new Promise((resolve, reject) => {
      client
        .query({
          query: CONSULTA
        })
        .then(job => {
          resolve(job);
        })
        .catch(e => reject(e));
    });
  };

  const ModelKirkaldy = async (bath_temperature, piece_temperature, diameter, isWater, agitation_level, hard_coat) => {
    const CONSULTA = gql`{
      runModeloKirkaldy (Diameter: ${diameter}, TempMedio: ${bath_temperature}, TempPieza: ${piece_temperature}, IsWater:${isWater}, Velocidad:${agitation_level}, EspesorCapa:${hard_coat} ) {
        Espesor
        error
      }
    }`;

    return new Promise((resolve, reject) => {
      client
        .query({
          query: CONSULTA
        })
        .then(job => {
          resolve(job);
        })
        .catch(e => reject(e));
    });
  };


  const ModelTempered = async (temperature, heating_ramp, diameter, enabled_ramp) => {

    const CONSULTA = gql`{
      runModeloRevenidoCilindro ( Diametro: ${diameter}, Temp_Horno: ${temperature}, Temp_inicial: 15, Temp_Ambiente :20,  RampaOnOff: ${enabled_ramp}, Rampa: ${heating_ramp}, ) {
          TiempoOptimoHorno
          error
      }
    }`;

    return new Promise((resolve, reject) => {
      client
        .query({
          query: CONSULTA
        })
        .then(job => {
          resolve(job);
        })
        .catch(e => reject(e));
    });
  };

  return {
    ModelHeating,
    ModelKirkaldy,
    ModelTempered
  };
};

export default CilynderModel;
